module.exports = __webpack_public_path__ + "static/media/delayedimpact.a2797719.svg";